import { Link, useLocation } from 'react-router-dom';
import NavDropdown from './NavDropdown';
import { useNavSections } from '../../hooks/useNavSections';

/**
 * Hamburger menu for mobile viewports (<768px).
 * Uses the generic NavDropdown for open/close/Esc/click-outside behavior.
 * Plain sections render as Links; dropdown sections render as a group with a
 * heading and their items as Links.
 */
export default function MobileNavMenu() {
    const sections = useNavSections();
    const location = useLocation();

    return (
        <NavDropdown
            trigger={
                <button type="button" className="mobile-nav-trigger" aria-label="Open navigation menu">
                    ☰
                </button>
            }
            panelClassName="mobile-nav-panel"
            aria-label="Navigation menu"
        >
            {sections.map((section) => {
                if (section.kind === 'dropdown') {
                    return (
                        <div key={section.id} className="mobile-nav-group">
                            <div className="mobile-nav-group-heading">{section.label}</div>
                            {section.items.map((item) => (
                                <Link
                                    key={item.id}
                                    to={item.to}
                                    className="nav-dropdown-item"
                                    role="menuitem"
                                >
                                    {item.label}
                                </Link>
                            ))}
                        </div>
                    );
                }

                const isActive = section.match(location.pathname);
                return (
                    <Link
                        key={section.id}
                        to={section.to}
                        className="nav-dropdown-item"
                        role="menuitem"
                        aria-current={isActive ? 'page' : undefined}
                    >
                        {section.label}
                    </Link>
                );
            })}
        </NavDropdown>
    );
}
